var isCpIcon = false;
var allianceJson = '/material/json/allianceList.json';
var pointcpJson = '/material/json/pointcpList.json';
var icons = document.querySelectorAll('.icon__open-modal');
var modalWrap = document.querySelector('.modal-wrap');
var modalOverlay = document.querySelector('.modal-wrap .overlay');

// スクロールを検知
$(function() {
	var isScroll = 0;
	var timeoutId;
	$(window).on('scroll', function() {
		isScroll = 1;
		clearTimeout(timeoutId);
		timeoutId = setTimeout(function() {
			isScroll = 0;
		}, 500);
	});
});

// タッチデバイスか非タッチデバイスかを判定
var isTouchDevice = 'ontouchstart' in window;
var clickEventType = 'click';
if (isTouchDevice) {
	clickEventType = 'touchend';
}
// アイコンのクリックイベント
$('.contents-wrap').on(clickEventType, '.icon__open-modal', function() {
	const keyword = 'cp';
	// アイコンのidを取得
	var id = $(this).attr('id');
	var classes = $(this).attr('class');
	var splitedClass = classes.split(' ');
	// ポイントアップキャンペーンスライダーのアイコンの場合はクラスからIDを取得
	if ($(this).hasClass('pointcp-slider__item')) {
		for (let i = 0; i < splitedClass.length; i++) {
			if (splitedClass[i].indexOf(keyword) === 0) {
				id = splitedClass[i];
				break;
			}
		}
	}
	// アイコンの種類によってデータの取得元のJSONを設定
	isCpIcon = id.indexOf(keyword) === 0;
	var jsonURL = allianceJson;
	if (isCpIcon) {
		jsonURL = pointcpJson;
	};
	// モーダルウィンドウを表示する
	fetch(jsonURL)
		.then(response => response.json())
		.then(json => formatModal(json, id));
});

// ×ボタン押下時イベント
$('.modal-wrap .modal-btn-close').click(function() {
	closeModal();
});

// モーダルウィンドウ以外を押下した際のイベント
$('.modal-wrap .overlay').click(function() {
	closeModal();
});

// モーダルウィンドウに表示する内容を設定
var formatModal = function(json, id) {
	// JSONからデータを取得
	var data = getSelectedData(json, id);
	// モーダルウィンドウに表示する内容を設定
	if (isCpIcon) {
		setCpContents(getCpKind(json, id), data);
	} else {
		setAllianceContents(data);
	}
	// モーダルウィンドウを表示する
	modalWrap.classList.add('is-active');
	modalOverlay.classList.add('is-active');
	// bodyのスクロールを不可にする
	document.body.style.overflow = 'hidden';
};

// JSONからクリックしたデータを取得
var getSelectedData = function(json, id) {
	for (let i = 0; i < json.length; i++) {
		for (let n = 0; n < json[i].data.length; n++) {
			let target = json[i].data[n];
			if (target.id === id) {
				return target;
			}
		}
	}
};

// ポイントアップキャンペーンのモーダルウィンドウの場合JSONからキャンペーンの種類を取得
var getCpKind = function(json, id) {
	// blockIdを取得
	var splitedId = id.split('-');
	var blockId = splitedId[0];
	for (let i = 0; i < json.length; i++) {
		if (json[i].blockId === blockId) {
			var cpKind = [];
			cpKind.push(json[i].frequency);
			cpKind.push(json[i].multiple);
			return cpKind;
		}
	}
};

// ポイントアップキャンペーンのモーダルウィンドウを作成
var setCpContents = function(cpKind, data) {
	modalWrap.classList.add('cp-modal');
	var modalHead = '<div class=\"pointcp__title\"><span class=\"title-text--normal\">' + cpKind[0] + '</span><div class=\"title-text--emphasis\"><span class=\"text__number\">' + cpKind[1] + '</span><span class=\"text__unit\">倍</span></div></div><p class=\"modal__name\">' + data.storeName + '</p></div>';
	$('#modal-head')[0].innerHTML = modalHead;
	var textContents = '';
	if (data.cpContent) {
		textContents = '※' + data.cpContent;
	}
	var modalText = '<div class=\"modal__text\"><p class=\"text-contents\">' + textContents + '</p></div>';
	var modalDate = '<div class=\"modal__date\"><p class=\"text-contents\">' + data.dateDisplayText + '</p></div>';
	var targetLickClass = 'link-text link-text--no-border';
	if (!data.targetStoreURL) {
		targetLickClass += ' is-noactive';
	}
	var modalTr1 = '<tr class=\"table-normal--w-type1\"><th>対象店舗</th><td><p>' + data.targetStore + '</p><a href=\"' + data.targetStoreURL + '\" target=\"_blank\" class=\"' + targetLickClass + '\"><span class=\"link-text__item\">対象店舗はこちら</span><img src=\"/material/img/common/icon/icon_pdf.png\" alt=\"対象店舗\"></a></td></tr>';
	var modalTr2 = '<tr><th>ポイント加算日</th><td>' + data.addPointDate + '</td></tr>';
	var trContents = '';
	if (data.otherMatters) {
		trContents = data.otherMatters;
	}
	if (data.otherMattersNoAsterisk) {
		trContents = data.otherMattersNoAsterisk;
	}
	var modalTr3 = trContents !== '' ? '<tr><th>その他特記事項</th><td>' + trContents + '</td></tr>' : '';
	var modalTable = '<table class=\"table-normal table-normal--sp-column mt30\">' + modalTr1 + modalTr2 + modalTr3 + '</table>';
	var modalBtnClass = 'index-wrap__row-btn mt30';
	if (!data.storeURL) {
		modalBtnClass += ' is-noactive';
	}
	var modalBtn = '<div class=\"' + modalBtnClass + '\"><div class=\"btn-link__wrap no-margin-top\"><a href=\"' + data.storeURL + '\" target=\"_blank\" class=\"btn-link btn-link--another-tab\">対象店舗の公式サイトはこちら</a>' + '</div></div>';
	var modalContents = modalText + modalDate + modalTable + modalBtn;
	$('#modal-content')[0].innerHTML = modalContents;
};

// 使えるお店のモーダルウィンドウを作成
var setAllianceContents = function(data) {
	var modalHead = '<div class=\"modal__logo\"><img src=\"' + data.logoPath + '\" alt=\"' + data.imgAltName + '\" id="al-modal-logo\"></div><p class=\"modal__name\" id=\"al-modal-name\">' + data.storeName + '</p></div>';
	$('#modal-head')[0].innerHTML = modalHead;
	var modalText = '<div class=\"modal__text\"><p class=\"text-contents\" id=\"al-modal-text\">' + data.text + '</p></div>';
	var typeListItem = 'type-list__item';
	var tamaru = 'type-list__item--tamaru';
	var charge = 'type-list__item--charge';
	var zandaka = 'type-list__item--zandaka';
	var koukan = 'type-list__item--koukan';
	var tamaruClass = typeListItem;
	var chargeClass = typeListItem;
	var zandakaClass = typeListItem;
	var koukanClass = typeListItem;
	var typeListIcon = '\"><p class=\"type-list__icon\">';
	if (data.tamaru) {
		tamaruClass += (' ' + tamaru);
	}
	if (data.charge) {
		chargeClass += (' ' + charge);
	}
	if (data.zandaka) {
		zandakaClass += (' ' + zandaka);
	}
	if (data.koukan) {
		koukanClass += (' ' + koukan);
	}
	var typeListHTML = '<ul class=\"type-list\"><li class=\"' + tamaruClass + typeListIcon + 'たまる</p></li><li class=\"' + chargeClass + typeListIcon + 'チャージ</p></li><li class=\"' + zandakaClass + typeListIcon + '残高確認</p></li><li class=\"' + koukanClass + typeListIcon + 'ポイント交換</p></li></ul>';
	var btnClass = 'index-wrap__row-btn';
	if (!data.storeURL) {
		btnClass += ' is-noactive';
	}
	var btnHTML = '<div class=\"' + btnClass + '\"><div class=\"btn-link__wrap no-margin-top\"><a href=\"' + data.storeURL + '\" target=\"_blank\" class=\"btn-link btn-link--another-tab\" id=\"al-modal-btn-link\">公式サイトはこちら</a></div></div>';
	var annotationClass = 'modal__annotation';
	if (!data.annotation) {
		annotationClass += ' is-noactive';
	}
	var annotationHTML = '<div class=\"' + annotationClass + '\"><p class=\"annotation__mark\">※&nbsp;</p><p class=\"annotation__text\" id=\"al-modal-annotation\">' + data.annotation + '</p></div>';
	var modalContents = modalText + typeListHTML + btnHTML + annotationHTML;
	$('#modal-content')[0].innerHTML = modalContents;
};

// モーダルウィンドウを閉じる
var closeModal = function() {
	modalWrap.classList.remove('cp-modal');
	modalWrap.classList.remove('is-active');
	modalOverlay.classList.remove('is-active');
	document.body.style.overflow = '';
};
